import { Package } from 'lucide-react';

import GitIcon from '@/assets/ico/git.svg?c';

import { FormSection } from '@@/form-components/FormSection';
import { BoxSelector, type BoxSelectorOption } from '@@/BoxSelector';

type DeployMethod = 'git' | 'manual';

export function UseGitFormSection({
  value,
  onChange,
}: {
  value: boolean;
  onChange: (value: boolean) => void;
}) {
  const deployMethod: DeployMethod = value ? 'git' : 'manual';

  const options: BoxSelectorOption<DeployMethod>[] = [
    {
      id: 'deploy_git',
      icon: GitIcon,
      iconType: 'logo',
      label: 'Git repository',
      description:
        'Deploy from a Git repository containing a Helm chart and values files. Supports automatic updates when the repository changes.',
      value: 'git',
    },
    {
      id: 'deploy_manual',
      icon: Package,
      iconType: 'badge',
      label: 'Helm repository',
      description:
        'Install from a Helm registry or repository. Requires manual updates when new versions are available.',
      value: 'manual',
    },
  ];

  return (
    <FormSection title="Deploy from" className="mb-8">
      <BoxSelector
        radioName="deploy-method"
        options={options}
        value={deployMethod}
        onChange={(method: DeployMethod) => {
          onChange(method === 'git');
        }}
      />
    </FormSection>
  );
}
